import script from "./LuceLauncher.vue?vue&type=script&setup=true&lang=js"
export * from "./LuceLauncher.vue?vue&type=script&setup=true&lang=js"

import "./LuceLauncher.vue?vue&type=style&index=0&id=081c953c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-081c953c"]])

export default __exports__